enum ProductGroupComponentEnum {
    STANDARD = "STANDARD",
    MODAL = "MODAL",
}

export default ProductGroupComponentEnum;
